<div class="container">
    <mat-accordion>
    <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Webflow
          </mat-panel-title>
          <mat-panel-description>
            <div *ngIf="item.webflow.isListed">
                Yes its on the website
            </div>
            <div *ngIf="!item.webflow.isListed">
                Unlisted
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>
    
        <div *ngIf="!isLoading">
    
            <div class="weblow-actions">
              <!-- <a href="https://www.facebook.com/marketplace/create/item" target="_blank" mat-raised-button>List</a>
              <button mat-raised-button (click)="generateDefaults()">Fill Defaults</button> -->
            </div>

            <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput [(ngModel)]="item.webflow.title" (blur)="save()">
            </mat-form-field>

            <mat-checkbox [(ngModel)]="item.webflow.isListed" (change)="save()">Is Listed</mat-checkbox>

        </div>
    
      </mat-expansion-panel>
    </mat-accordion>
    
    
    </div>